import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  pageTitle = 'GDPR';
  logoLink: any;
  Language: string;
  isENPrivacyVisible = true;
  isNativeLanguagePrivacyVisible = false;
  apacenprivacynotice: string;
  currentYear: any;

  constructor() { }

  ngOnInit() {
    this.Language = window.location.href;
    this.currentYear = new Date().getFullYear();
    this.isNativeLanguagePrivacyVisible = true;
    if (this.Language.indexOf('/cn/') !== -1) {
      this.apacenprivacynotice = '/cn/#/apac-en-privacy-notice';
    }
    if (this.Language.indexOf('/tw/') !== -1) {
      this.apacenprivacynotice = '/tw/#/apac-en-privacy-notice';
    }
    if (this.Language.indexOf('/hk/') !== -1) {
      this.apacenprivacynotice = '/hk/#/apac-en-privacy-notice';
    }
    if (this.Language.indexOf('/jp/') !== -1) {
      this.apacenprivacynotice = '/jp/#/jp-en-privacy-notice';
    }
    if (this.Language.indexOf('/sk/') !== -1) {
      this.apacenprivacynotice = '/sk/#/apac-en-privacy-notice';
    }

    this.logoLink = 'assets/logo-market-intelligence-flush.svg';

    if (this.Language.indexOf('/cn/') !== -1 || this.Language.indexOf('/tw/') !== -1 || this.Language.indexOf('/hk/') !== -1
    || this.Language.indexOf('/jp/') !== -1 || this.Language.indexOf('/sk/') !== -1) {
      this.isENPrivacyVisible = true;
    } else {
      this.isENPrivacyVisible = false;
    }

    if (this.Language.indexOf('/sk/') !== -1) {
      this.isNativeLanguagePrivacyVisible = false;
    }

    if ((this.Language.indexOf('/sk/') !== -1)
      && (this.Language.indexOf('apac-en-privacy-notice') !== -1 || this.Language.indexOf('privacy-notice') !== -1 )  ) {
      this.isNativeLanguagePrivacyVisible = false;
      this.isENPrivacyVisible = false;
    }
  }
}

